import { useEventBus } from '@vueuse/core'
import type { WhoAmI } from '@/stores'

/**
 * This composable should serve titrop application events
 */
export function useTitropEvents() {
  return {
    onLoginSuccess: useEventBus<WhoAmI>('auth.login_success'),
    onLogout: useEventBus('auth.logout'),
    onTokenRefreshed: useEventBus('auth.token_refreshed'),
    onMercureConnected: useEventBus<never, never>('mercure-connected'),
    onMercureDisconnected: useEventBus<never, never>('mercure-disconnected'),

    onEmployeeConfigLoaded: useEventBus<never, never>('onEmployeeConfigLoaded'),
    onTitropReady: useEventBus<never, never>('onTitropReady'),
    onTitropUnready: useEventBus<never, never>('onTitropUnready'),

    //events for hotkeys (should be named 'hotkey<verb><component>')
    hotkeyToggleDeveloperDialog: useEventBus<never, never>('hotkeyDeveloperDialogToggle'),
    hotkeyToggleHotkeyHelpDialog: useEventBus<never, never>('hotkeyHotkeyHelpDialogToggle'),
    hotkeyToggleNoticesSidebar: useEventBus<never, never>('hotkeyNoticesSidebarToggle'),
    hotkeyGotoEffortToggle: useEventBus<never, never>('hotkeyGotoEffortToggle'),
    hotkeyFocusSearch: useEventBus<never, never>('hotkeySearch'),
    hotkeyToggleStatusChangeDialog: useEventBus<never, never>('hotkeyStatusChange'),
    hotkeyToggleActivityFeed: useEventBus<never, never>('hotkeyActivityFeedToggle'),
    hotkeyChangeSearchScope: useEventBus<never, { scope: number }>('hotkeyChangeSearchScope')
  }
}
